import React, { useEffect, useState } from "react";
import Certifs_Veiki_Vnl from "./Certifs_Veiki_Vnl";
import Loader from "./Loader";
import Header from "./Header";
import Footer from "./Footer";
import Form from "./Form";
import NosAdresses from "./NosAdresses";
import EquipeExport from "./EquipeExport";
import EquipeCommercialLocal from "./EquipeCommercialLocal";
import Header_sav from "./Header_sav";

const ContactUs = () => {
  // State to control visibility
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Delay the visibility of the component
    const timer = setTimeout(() => {
      setIsVisible(true); // Set to visible after the delay
    }, 200);

    return () => clearTimeout(timer); // Clean up on unmount
  }, []);
  return (
    <div>
      <div>
        <Header_sav />
      </div>
      <Loader isVisible={isVisible} />
      <div style={{ paddingTop: "120px" }}>
        
        <section
          className="shop-tab page-section-ptb"
          style={{ paddingBottom: "0px" }}
        >
          <div className="container">
          <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="section-title text-center">
                  <h2 className="title-effect">
                    Nos experts en développement commercial
                  </h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="tab tab-border nav-center">
                  <ul className="nav nav-tabs" id="productsTab" role="tablist">
                  <li className="nav-item">
                      <a
                        className="nav-link active show"
                        id="Local-tab"
                        data-toggle="tab"
                        href="#Local"
                        role="tab"
                        aria-controls="Local"
                        aria-selected="true"
                      >
                        {" "}
                        Local
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link "
                        id="Export-tab"
                        data-toggle="tab"
                        href="#Export"
                        role="tab"
                        aria-controls="Export"
                        aria-selected="true"
                      >
                        {/**<img src="/assets/images/Certificat/kema.png" alt="" /> */}{" "}
                        Export
                      </a>
                    </li>
                    {/** */}
                    
                
                  </ul>
                  {/** */}
                  <div className="tab-content" id="productsTabContent">
                   {/** */}
                  <div
                      className="tab-pane fade active show"
                      id="Local"
                      role="tabpanel"
                      aria-labelledby="EquipeCommercialLocal"
                    >
                      <EquipeCommercialLocal />
                    </div>
                    {/** */}
                    <div
                      className="tab-pane fade "
                      id="Export"
                      role="tabpanel"
                      aria-labelledby="EquipeExport"
                    >
                      <EquipeExport />
                    </div>
                   
                    
                   
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="page-section-ptb">
          <div className="container">
           
            <div className="row">
              

              {/*=================================Form */}
              <div
                style={{
                  width: "1170px",
                  paddingTop: "40px",
                  paddingBottom: "20px",

                  border: "2px solid #eeeeee",
                }}
              >
                {/**<Form /> */} <Form />
              </div>

              {/*=================================Maps */}
              <div
                style={{
                  width: "1170px",
                  paddingTop: "40px",
                }}
              >
                <NosAdresses />
              </div>

              {/*=================================Form */}
            </div>
          </div>
        </section>

        
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default ContactUs;
